import Login from './views/login/main.vue'
import Menu from './views/menu/main.vue'
import Inicio from './views/inicio/main.vue'
import Cliente from './views/cliente/main.vue'
import Servico from './views/servico/main.vue'
import ServidorEnvio from './views/servidor-envio/main.vue'
import Equipamento from './views/equipamento/main.vue'
//import Ticket from './views/ticket/geral/main.vue'
// import Dashboard		from  './views/dashboard/main.vue'
import Processamento from './views/processamento/main.vue'
import Monitoramento from './views/monitoramento/main.vue'

import Perfil from './views/adm/perfil/main.vue'
import Usuario from './views/adm/usuario/main.vue'
import Sistema from './views/adm/sistema/main.vue'
import ModuloGeral from './views/adm/modulo-geral/main.vue'
import ModuloSistema from './views/adm/modulo-sistema/main.vue'
import Privilegio from './views/adm/privilegio/main.vue'
import NotificacaoConfig from './views/adm/notificacao-config/main.vue'

import Fabricante from './views/followair/fabricante/main.vue'
import Modelo from './views/followair/modelo/main.vue'
import Manutencao from './views/followair/manutencao/main.vue'
import Local from './views/followair/local/main.vue'
import AtualizacaoManual from './views/followair/atualizacao-manual/main.vue'

import Ticket from './views/ticket/geral/main.vue'
import Projeto from './views/ticket/projeto/main.vue'
import TipoTicket from './views/ticket/tipo-ticket/main.vue'
import Status from './views/ticket/status/main.vue'
import Designado from './views/ticket/geral/main.vue'
// function loadView(view) {
// 	return () => import(/* webpackChunkName: "[view].js" */ `${view}.vue`)
// }

export default [
	{ path: '/login', component: Login, name: 'login' },
	{
		path: '/', component: Menu, name: 'menu',
		children: [
			{ modulo: 0, privilegio: 0, path: '/inicio', component: Inicio, name: 'inicio' },
			// { modulo: 0, privilegio: 0, path: '/dashboard', component : Dashboard, name: 'dashboard' },
			{ modulo: 3, privilegio: 23, path: '/cliente', component: Cliente, name: 'cliente' },
			{ modulo: 4, privilegio: 25, path: '/servico', component: Servico, name: 'servico' },
			{ modulo: 7, privilegio: 14, path: '/servidor-envio', component: ServidorEnvio, name: 'servidor-envio' },
			{ modulo: 5, privilegio: 24, path: '/equipamento', component: Equipamento, name: 'equipamento' },

			{ modulo: 2, privilegio: 1, path: '/monitoramento', component: Monitoramento, name: 'monitoramento' },

			{ modulo: 14, privilegio: 37, path: '/processamento', component: Processamento, name: 'processamento' },

			// ADM
			{ modulo: 9, privilegio: 22, path: '/adm/modulo-sistema', component: ModuloSistema, name: 'modulo-sistema' },
			{ modulo: 9, privilegio: 22, path: '/adm/privilegio', component: Privilegio, name: 'privilegio' },
			{ modulo: 11, privilegio: 31, path: '/adm/notificacao-config', component: NotificacaoConfig, name: 'notificacao-config' },
			{ modulo: 9, privilegio: 22, path: '/adm/perfil', component: Perfil, name: 'perfil' },
			{ modulo: 8, privilegio: 18, path: '/adm/usuario', component: Usuario, name: 'usuario' },
			{ modulo: 8, privilegio: 18, path: '/adm/sistema', component: Sistema, name: 'sistema' },
			{ modulo: 8, privilegio: 18, path: '/adm/modulo-geral', component: ModuloGeral, name: 'modulo-geral' },

			// FOLLOWAIR
			{ modulo: 12, privilegio: 34, path: '/followair/fabricantes', component: Fabricante, name: 'fabricantes' },
			{ modulo: 12, privilegio: 34, path: '/followair/modelos', component: Modelo, name: 'modelos' },
			{ modulo: 13, privilegio: 35, path: '/followair/manutencao', component: Manutencao, name: 'manutencao' },
			{ modulo: 13, privilegio: 35, path: '/followair/atualizacoes', component: AtualizacaoManual, name: 'atualizacoes' },
			{ modulo: 0, privilegio: 0, path: '/followair/local', component: Local, name: 'local' },

			// TICKET
			{ modulo: 10, privilegio: 27, path: '/ticket/geral', component: Ticket, name: 'ticket' },
			{ modulo: 15, privilegio: 0, path: '/ticket/projeto', component: Projeto, name: 'projeto' },
			{ modulo: 16, privilegio: 0, path: '/ticket/tipo-ticket', component: TipoTicket, name: 'tipo-ticket' },
			{ modulo: 17, privilegio: 0, path: '/ticket/status', component: Status, name: 'status' },
			// { modulo: 18, privilegio: 0, path: '/ticket/designado', component: Designado, name: 'designado' },
			// { modulo: 18, privilegio: 0, path: '/ticket/designado', component: Designado, name: 'designado' },
		]
	},
]



// WEBPACK FOOTER //
// ./src/routers.js